import { Mutation, RestApiKey } from 'graphql/generated/graphqlTypes';
import { generateMockRestApiKey } from 'mocks/graphqlMocks/restApiKey';

export function mockedUpdateRestAPIKeyData(updateRestApiKey: RestApiKey): Pick<Mutation, 'updateRestApiKey'> {
  return {
    updateRestApiKey
  };
}

export const mockedUpdateRestAPIKeyDataForMutation = mockedUpdateRestAPIKeyData(
  generateMockRestApiKey({
    id: 'mock-key-1',
    description: 'updatedName'
  })
);
